import React from 'react'
import Header from '../../Components/Header'
import AboutUs from "../../Components/aboutUs"





const AboutUsPage = () => {
  return (
    <div>
    <Header />
      <AboutUs/>
    </div>
  )
}

export default AboutUsPage